import React, { Component } from 'react';
import I18n from '~/utils/translations';

export default class CoBrandingBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  textColour(brandColor) {
    const hex = brandColor.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

    return brightness > 155 ? '#262d4e' : '#ffffff';
  }

  render() {
    const { findLogoUrl, joinLogoUrl, brandLogoImageUrl, findPartnerExternalName, brandColor } = this.props.portfolio;
    const logoUrl = findLogoUrl || brandLogoImageUrl || joinLogoUrl;
    const color = this.textColour(brandColor);

    return (
      <section className="home-co-branded-banner" style={{ backgroundColor: brandColor, color: color }}>
        <div>
          <p>{I18n.t('pages.homes.co_branded_banner.title')}</p>
          {logoUrl && <img className="home-co-branded-banner__logo" src={logoUrl} />}
          {!logoUrl && <span>{findPartnerExternalName}</span>}
        </div>
      </section>
    );
  }
}
